import type { MenuItem } from '../types';
import type { BootstrapPayload, ProductRecord, ScenarioSnapshot, ScenarioSummaryRecord } from './types';

export function mapBootstrapScenarioToSnapshot(payload: BootstrapPayload['scenario']): ScenarioSnapshot | null {
  if (!payload) {
    return null;
  }

  const source = payload.snapshot && typeof payload.snapshot === 'object'
    ? payload.snapshot
    : {};

  const snapshot = source as Partial<ScenarioSnapshot>;

  return {
    scenarioId: payload.id,
    scenarioName: payload.name,
    gridSize: snapshot.gridSize ?? { cols: 16, rows: 10 },
    walls: snapshot.walls ?? [],
    tables: snapshot.tables ?? [],
    showPrices: typeof snapshot.showPrices === 'boolean' ? snapshot.showPrices : false,
    itemizePrintItems: typeof snapshot.itemizePrintItems === 'boolean' ? snapshot.itemizePrintItems : false,
    lightTableColor: snapshot.lightTableColor,
    darkTableColor: snapshot.darkTableColor,
    lightWallColor: snapshot.lightWallColor,
    darkWallColor: snapshot.darkWallColor,
    status: payload.status ?? snapshot.status ?? 'ACTIVE',
    isDefault: payload.isDefault ?? snapshot.isDefault ?? false,
    currentVersion: payload.currentVersion,
    updatedAt: payload.updatedAt,
  };
}

export function mapScenarioSummary(payload: BootstrapPayload['scenarios'][number]): ScenarioSummaryRecord {
  return {
    id: payload.id,
    name: payload.name,
    status: payload.status,
    isDefault: payload.isDefault,
    currentVersion: payload.currentVersion,
    updatedAt: payload.updatedAt,
    hasLocalSnapshot: false,
  };
}

export function mapProductsToMenuItems(products: ProductRecord[]): MenuItem[] {
  return products
    .filter((product) => product.isActive !== false && product.categoryIsActive !== false)
    .map((product) => ({
      id: product.id,
      name: product.name,
      price: product.price ?? null,
      categoryId: product.categoryId,
      categoryName: product.categoryName,
    }));
}
